import { render } from "./FatButtonContainer.vue?vue&type=template&id=9adee170&scoped=true&ts=true"
import script from "./FatButtonContainer.vue?vue&type=script&lang=ts"
export * from "./FatButtonContainer.vue?vue&type=script&lang=ts"

import "./FatButtonContainer.vue?vue&type=style&index=0&id=9adee170&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9adee170"]])

export default __exports__